import api from "./api";
// 查询勋章列表
export const fetchMedaltList = params => {
  return api("post", `/v1/management/medal/list`, params);
};

// 设置勋章上下架
export const upMedaltStatus = params => {
  return api("post", `/v1/management/medal/medal-status`, params);
};

// 导入勋章名单
export const putMedalUp = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", `/v1/management/medal/upload`, params, config);
};
